import React from "react";
import SglContext from '../SglContext';
import { useNavigate } from 'react-router-dom';
import VideoSubscription from "../videos/VideoSubscription";
import "./subscription.css";

class Subscription extends React.Component {
    state = {
    };

    constructor(props) {
        super(props);
        // bind function in constructor instead of render
        this.playVideoAfterSubscribe = this.playVideoAfterSubscribe.bind(this);
        this.closeDoSubscriptionModal = this.closeDoSubscriptionModal.bind(this);

    }
    componentDidMount(){
        document.title = 'Subscriptions';
    }

    closeDoSubscriptionModal(){
    }
    playVideoAfterSubscribe(){
        const { navigate } = this.props;
        navigate('/videos');
    }
    render() {

        return (
            <div className="sgl-plugin">
                {/* <h1>Video Subscription</h1> */}
                <div className='sub-main-div'>
                    <VideoSubscription 
                        is_download_subscription = {false} 
                        is_video_subscription = {false}
                        subscription_type = {'video'}
                        video_to_play = {{videos_sgl_id:-1}}
                        closeSubscriptionModal = {this.closeDoSubscriptionModal}
                        playVideoAfterSubscribe = {this.playVideoAfterSubscribe}
                        //   ref = {this.VideoSubscriptionElement}
                    />
                </div>

            </div>
        );
    }
}
Subscription.contextType = SglContext;
export default function(props) {
    const navigate = useNavigate();

    return <Subscription {...props} navigate={navigate} />;
}
